import Papa from 'papaparse';
import axios from 'axios';
import { API_BASE_URL } from './config';
import { buildFrfSeries } from './frfCsvData';

const AssembleCsvreader = (file, setData) => {
  const sendToBackend = (data) => {
    localStorage.setItem("AssembleLoading", "true");

    const dataset = {
      freq: data.freq,
      magdb: data.magdb,
      phase: data.phase
    };

    const MAX_RETRIES = 5; // 最大重試次數
    const RETRY_DELAY = 400; // 重試間隔時間（4毫秒）

    const fetchData = (retryCount = 0) => {
      axios.post(`${API_BASE_URL}/assemble-read-csv`, dataset, { timeout: 10000 })
        .then(response => {
          const formattedAmpPeakData = response.data.Amp_peak_data.map(num => Number(num).toFixed(4));
          const formattedAmpPeakFreqData = response.data.Amp_peak_freq_data.map(num => {
            return parseFloat(Number(num).toFixed(2)); // 去掉小數點
          });
          const dampingRatioData = Array.isArray(response.data.Damping_ratio_data)
            ? response.data.Damping_ratio_data
            : [];

          setData({
            ...response.data,
            Amp_peak_data: formattedAmpPeakData,
            Amp_peak_freq_data: formattedAmpPeakFreqData,
            Damping_ratio_data: dampingRatioData,
            chartData
          });

          console.log('Success:', response.data);

          // 如果數據為0則重整頁面
          if (formattedAmpPeakData.every(num => num === '0.0000')) {
            setTimeout(() => {
              localStorage.setItem("AssembleLoading", "false");
              window.location.reload();
            }, RETRY_DELAY);
          } else {
            localStorage.setItem("AssembleLoading", "false");
          }
        })
        .catch(error => {
          console.error(`Error: ${error}, retry count: ${retryCount}`);

          // 設定預設值，避免 UI 崩潰
          setData({
            Amp_peak_freq_data: Array(6).fill(0).map(num => parseFloat(num.toFixed(2))),
            Amp_peak_data: Array(6).fill(0).map(num => num.toFixed(4)),
            Damping_ratio_data: Array(6).fill(null),
            Error_freq: Array(6).fill(''),
            Error_amp: Array(6).fill(''),
            chartData
          });

          if (retryCount < MAX_RETRIES) {
            console.log(`Retrying... (${retryCount + 1}/${MAX_RETRIES})`);
            setTimeout(() => fetchData(retryCount + 1), RETRY_DELAY); // 0.4 秒後重試
          } else {
            console.log('已達最大重試次數，執行頁面重整');
            window.location.reload(); // 重試失敗後頁面重新刷新
          }
        });
    };
    fetchData();
  };

  // const toDegrees = (radians) => radians * (180 / Math.PI);
  const chartData = {};

  Papa.parse(file, {
    download: true,
    dynamicTyping: true,
    delimiter: "",
    complete: (results) => {
      const frfSeries = buildFrfSeries(results.data);

      chartData.freq = frfSeries.freq;
      chartData.magn = frfSeries.magn;
      chartData.phase = frfSeries.phase;
      chartData.magdb = frfSeries.magdb;
      chartData.filename = results.data[0][1];
      chartData.time = results.data[1][1];
      chartData.ch_name = chartData.filename.split('_')[1] + "_" + chartData.filename.split('_')[2];// 提取檔案名稱中的分類

      sendToBackend(chartData);
    }
  });
};

export default AssembleCsvreader;
